// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__yAd8z","header":"ReportDetails_header__Nkbv0","title":"ReportDetails_title__2iP5s","left":"ReportDetails_left__3HHVj"};